import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { SalesPromotionList } from './components';
import { SalesPromotionActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    }
})

const IdentitySelector = (state) => state.Identity;

const SalesPromotion = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    // アクションを取得
    const salesPromotionActions = bindActionCreators(SalesPromotionActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    // トークンID, ユーザ情報を取得
    const { token, userData } = useSelector(IdentitySelector);

    const [mode, setMode] = useState('list');
    const [listRefresh, setListRefresh] = useState(true);

    // props引数パラメータを取得
    const { classes } = props;

    var listClass = classes.hiddenList;
    if (mode == 'list') {
        // 販促物一覧を表示するCSS設定
        listClass = classes.visibleList;
    }

    return (
        <div className={classes.root} maxWidth={false}>
            <div className={listClass}>
                <SalesPromotionList refresh={listRefresh} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(SalesPromotion);
